/*
 *  Author: DL
 *  Date: 2020-12-16 15:28:56
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-16 15:53:14
 *  LastEditors: DL
 *  Description: 历史记录
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

export function getHistoricalData() {
    const historicalDataStorage = localStorage.getItem('historicalData');
    const historicalData = historicalDataStorage ? JSON.parse(historicalDataStorage) : [];
    return historicalData;
}

export function isExist(FID) {
    const data = getHistoricalData();
    return data.some(item => item.FID === FID);
}

export function getItemByFID(FID) {
    const data = getHistoricalData();
    const items = data.filter(item => item.FID === FID);
    return items.length > 0 ? items[0] : null;
}

export function updateHistoricalData(item) {
    const data = getHistoricalData();
    if (data.length === 10) {
        data.pop();
    }
    data.unshift(item);
    localStorage.setItem('historicalData', JSON.stringify(data));
    return data;
}

export function clearHistoryData() {
    localStorage.removeItem('historicalData');
}
